import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { SectionCard } from "@/components/Common";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const PLAN_TR = { monthly: "Aylık", yearly: "Yıllık" };
const tl = (v) => (v == null ? "—" : `${new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2 }).format(Number(v))} TL`);

function Row({ r, onDone }) {
  const [busy, setBusy] = useState(false);
  const failed = (r.attempts || []).filter((a) => a.status === "failed");
  const lastFail = failed[failed.length - 1];
  const resend = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/pricing/notifications/${r.price_id}/${r.company_id}/resend`);
      data.ok ? toast.success("Bildirim mail sağlayıcısı tarafından kabul edildi") : toast.error("Mail yine gönderilemedi");
      onDone();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Yeniden gönderilemedi");
      onDone();
    } finally { setBusy(false); }
  };
  const key = `${r.price_id}-${r.company_id}`;
  return (
    <tr data-testid={`price-notice-failed-row-${key}`}>
      <td className="px-4 py-2">{r.company_name || r.company_id}</td>
      <td className="px-4 py-2">{r.email || "—"}</td>
      <td className="px-4 py-2">{PLAN_TR[r.plan]} · {tl(r.gross_price)}</td>
      <td className="px-4 py-2 whitespace-nowrap">{lastFail?.at ? fmtDateTime(lastFail.at) : fmtDateTime(r.created_at)}</td>
      <td className="px-4 py-2">{failed.length || 1}</td>
      <td className="px-4 py-2 whitespace-nowrap" data-testid={`price-notice-status-${key}`}>
        {r.status === "sent" ? `Kabul edildi · ${fmtDateTime(r.notification_sent_at)}` : "Başarısız"}
      </td>
      <td className="px-4 py-2">
        <Button size="sm" variant="outline" disabled={busy || !r.can_resend} onClick={resend} data-testid={`price-notice-resend-btn-${key}`}>
          {busy ? "Gönderiliyor..." : "Yeniden Gönder"}
        </Button>
      </td>
    </tr>
  );
}

export const PriceNoticeFailures = ({ reloadKey }) => {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => {
    api.get("/admin/pricing/notifications/failed").then(({ data }) => setRows(data))
      .catch(() => toast.error("Başarısız bildirimler yüklenemedi"));
  }, []);
  useEffect(() => { load(); }, [load, reloadKey]);
  return (
    <SectionCard title="Başarısız Fiyat Bildirimleri">
      <div className="overflow-x-auto" data-testid="price-notice-failures">
        {rows.length === 0 ? (
          <div className="p-5 text-sm text-slate-500" data-testid="price-notice-failures-empty">Başarısız bildirim yok.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="text-left text-xs uppercase text-slate-500">
              <tr>{["Firma", "E-posta", "Plan / Yeni fiyat", "Son hata", "Başarısız deneme", "Durum", ""].map((h) => <th key={h} className="px-4 py-2 font-semibold whitespace-nowrap">{h}</th>)}</tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {rows.map((r) => <Row key={`${r.price_id}-${r.company_id}`} r={r} onDone={load} />)}
            </tbody>
          </table>
        )}
      </div>
    </SectionCard>
  );
};
